export default "__VITE_ASSET__tYjxMN0o__"